angular.module('autoremind.communications')
    .directive('messagingDetails', ['messagesService', function (messagesService) {
        return {
            restrict: 'E',
            templateUrl: 'app/communication/messaging-details.html',
            link: function (scope, elem, attr) {
                scope.messagesService = messagesService;
                scope.viewModel = {
                    messages: []
                };
                scope.loadMessages = function () {
                    messagesService.offset = 0;
                    scope.viewModel.messages = [];
                    messagesService.getMessages(scope.jobId, null, 'full')
                        .then(function (data) {
                        console.log('scope.loadMessages', data);
                        for (var i in data.messages) {
                            data.messages[i].createdMs = data.messages[i].created;
                            scope.viewModel.messages.push(data.messages[i]);
                        }
                    }, function (error) {
                    });
                }();
            }
        };
    }]);
//# sourceMappingURL=messaging-details.directive.js.map